import PropTypes from 'prop-types';

const propTypes = {
  columns: PropTypes.func,
  visitorColumns: PropTypes.func,
  handleClickOnRowRight: PropTypes.func,
  handleClickOnRowLeft: PropTypes.func,
  modalContentLeft: PropTypes.object,
  modalContentRight: PropTypes.object,
  localTableData: PropTypes.array,
  visitorTableData: PropTypes.array,
  setModalContentLeft: PropTypes.func,
  setModalContentRight: PropTypes.func,
  selectedMatch: PropTypes.object,
  isFetching: PropTypes.bool,
  placeholderNumElements: PropTypes.number,
};

const defaultProps = {
  columns: () => {},
  visitorColumns: () => {},
  handleClickOnRowRight: () => {},
  handleClickOnRowLeft: () => {},
  modalContentLeft: {},
  modalContentRight: {},
  localTableData: [],
  visitorTableData: [],
  setModalContentLeft: () => {},
  setModalContentRight: () => {},
  selectedMatch: {},
  isFetching: false,
  placeholderNumElements: 11,
};

export { propTypes, defaultProps };
